import { useState, useEffect } from 'react';

/**
 * Un hook personalizado que rota a través de un array de frases
 * a un intervalo de tiempo específico.
 * @param phrases - Un array de strings con las frases para rotar.
 * @param intervalTime - El tiempo en milisegundos entre cada cambio de frase.
 * @returns La frase actual del array.
 */
export const useRotatingText = (phrases: string[], intervalTime: number = 4000): string => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    // No hacer nada si no hay frases
    if (!phrases || phrases.length === 0) return;

    // Configurar un intervalo que cambie el índice de la frase
    const intervalId = setInterval(() => {
      // Usamos el módulo para que el índice vuelva a 0 al llegar al final
      setCurrentIndex((prevIndex) => (prevIndex + 1) % phrases.length);
    }, intervalTime);

    // Es importante limpiar el intervalo cuando el componente ya no se use
    // para evitar fugas de memoria.
    return () => clearInterval(intervalId);
  }, [phrases, intervalTime]); // El efecto se reinicia si las frases o el intervalo cambian

  return phrases[currentIndex];
};
